import cookiesParams from './cookiesParams';

export function getCookieDomain(hostname) {
  if (hostname === 'localhost') {
    return undefined; // omit Domain on localhost
  }
  const parts = hostname.split('.');
  const tld = parts.pop();
  const sld = parts.pop();
  return sld && tld ? `${sld}.${tld}` : undefined;
}

export function setCookie(name, value, expireAt) {
  const host = window.location.hostname;
  const domain = getCookieDomain(host);
  const isHttps = window.location.protocol === 'https:';
  const expires = expireAt instanceof Date ? expireAt.toUTCString() : expireAt;

  // Chrome requires Secure when SameSite=None; on HTTP use Lax instead
  const sameSite = isHttps ? 'None' : 'Lax';
  const secureAttr = isHttps ? ';Secure' : '';
  const domainAttr = domain ? `;Domain=${domain}` : '';

  document.cookie = `${name}=${encodeURIComponent(value)};Expires=${expires}${domainAttr};Path=/;SameSite=${sameSite}${secureAttr}`;
}

export function setAcceptCookie() {
  const futureDate = new Date();
  futureDate.setHours(futureDate.getHours() + cookiesParams.consent.maxAgeHours);
  setCookie(cookiesParams.consent.name, cookiesParams.consent.value, futureDate);
}

export function setAuthCookie(token, expireAt) {
  const gmtExpireAt = new Date(expireAt);
  setCookie(cookiesParams.auth.name, token, gmtExpireAt.toUTCString());
}

export function setLocaleCookie(locale) {
  setCookie(cookiesParams.locale.name, locale);
}

export function setReloadBookingsCookie(value) {
  setCookie(cookiesParams.loadBookingsFlag.name, value);
}
